{
  "version": 1,
  "meta": {
    "id": "harmonic-oscillator",
    "name": "Harmonic Oscillator",
    "description": "Springs, bounces, and the elegant arc of a damped wave.",
    "author": "TriggernometryDash",
    "difficulty": "easy",
    "version": 1,
    "parTime": 52000,
    "optimalInputs": 22,
    "tags": ["tutorial", "jumppads", "real"]
  },
  "settings": {
    "initialMode": "real",
    "initialSpeed": 1.0,
    "initialPlayerMode": "triangle",
    "baseColor": "#33ff66",
    "accentColor": "#ffffff",
    "backgroundColor": "#0a0a18",
    "gridIntensity": 0.6,
    "music": {
      "bpm": 116,
      "key": "Am",
      "style": "synthwave",
      "song": "crystal-cave",
      "layers": ["bass", "drums"]
    },
    "fog": { "near": 50, "far": 200, "color": "#0a0a18" }
  },
  "segments": [
    {
      "id": "seg-01-intro",
      "mode": "real",
      "length": 600,
      "speed": 1.0,
      "terrain": {
        "type": "flat",
        "floor": { "function": "constant", "offset": 80 },
        "ceiling": null
      },
      "obstacles": [],
      "decorations": []
    },
    {
      "id": "seg-02-first-pad",
      "mode": "real",
      "length": 800,
      "speed": 1.0,
      "terrain": {
        "type": "flat",
        "floor": { "function": "constant", "offset": 80 },
        "ceiling": null
      },
      "obstacles": [
        {
          "type": "spike",
          "position": { "along": 350, "across": 0, "up": 0 },
          "size": { "width": 24, "height": 36 }
        },
        {
          "type": "jumppad",
          "position": { "along": 220, "across": 0, "up": 0 },
          "size": { "width": 0, "height": 0 },
          "visual": { "color": null, "glow": 1, "padSize": "small" }
        }
      ],
      "decorations": []
    },
    {
      "id": "seg-03-medium-chain",
      "mode": "real",
      "length": 700,
      "speed": 1.0,
      "terrain": {
        "type": "flat",
        "floor": { "function": "constant", "offset": 80 },
        "ceiling": null
      },
      "obstacles": [
        {
          "type": "jumppad",
          "position": { "along": 150, "across": 0, "up": 0 },
          "size": { "width": 0, "height": 0 },
          "visual": { "color": null, "glow": 1, "padSize": "medium" }
        },
        {
          "type": "spike",
          "position": { "along": 320, "across": 0, "up": 0 },
          "size": { "width": 24, "height": 36 }
        },
        {
          "type": "jumppad",
          "position": { "along": 460, "across": 0, "up": 0 },
          "size": { "width": 0, "height": 0 },
          "visual": { "color": null, "glow": 1, "padSize": "medium" }
        }
      ],
      "decorations": []
    },
    {
      "id": "seg-04-top-land-hint",
      "mode": "real",
      "length": 700,
      "speed": 1.0,
      "terrain": {
        "type": "flat",
        "floor": { "function": "constant", "offset": 80 },
        "ceiling": null
      },
      "obstacles": [
        {
          "type": "jumppad",
          "position": { "along": 200, "across": 0, "up": 0 },
          "size": { "width": 0, "height": 0 },
          "visual": { "color": null, "glow": 1, "padSize": "small" }
        },
        {
          "type": "jumppad",
          "position": { "along": 420, "across": 0, "up": 0 },
          "size": { "width": 0, "height": 0 },
          "visual": { "color": null, "glow": 1, "padSize": "small" }
        }
      ],
      "decorations": []
    },
    {
      "id": "seg-05-gauntlet",
      "mode": "real",
      "length": 900,
      "speed": 1.0,
      "terrain": {
        "type": "flat",
        "floor": { "function": "constant", "offset": 80 },
        "ceiling": null
      },
      "obstacles": [
        {
          "type": "jumppad",
          "position": { "along": 120, "across": 0, "up": 0 },
          "size": { "width": 0, "height": 0 },
          "visual": { "color": null, "glow": 1, "padSize": "small" }
        },
        {
          "type": "spike",
          "position": { "along": 250, "across": 0, "up": 0 },
          "size": { "width": 24, "height": 36 }
        },
        {
          "type": "jumppad",
          "position": { "along": 380, "across": 0, "up": 0 },
          "size": { "width": 0, "height": 0 },
          "visual": { "color": null, "glow": 1, "padSize": "medium" }
        },
        {
          "type": "spike",
          "position": { "along": 530, "across": 0, "up": 0 },
          "size": { "width": 24, "height": 36 }
        },
        {
          "type": "spike",
          "position": { "along": 580, "across": 0, "up": 0 },
          "size": { "width": 24, "height": 36 }
        },
        {
          "type": "jumppad",
          "position": { "along": 720, "across": 0, "up": 0 },
          "size": { "width": 0, "height": 0 },
          "visual": { "color": null, "glow": 1, "padSize": "large" }
        }
      ],
      "decorations": []
    },
    {
      "id": "seg-06-the-wall",
      "mode": "real",
      "length": 800,
      "speed": 1.0,
      "terrain": {
        "type": "flat",
        "floor": { "function": "constant", "offset": 80 },
        "ceiling": null
      },
      "obstacles": [
        {
          "type": "jumppad",
          "position": { "along": 200, "across": 0, "up": 0 },
          "size": { "width": 0, "height": 0 },
          "visual": { "color": null, "glow": 1, "padSize": "large" }
        },
        {
          "type": "wall",
          "position": { "along": 280, "across": 0, "up": 0 },
          "size": { "width": 30, "height": 160 }
        },
        {
          "type": "spike",
          "position": { "along": 320, "across": 0, "up": 0 },
          "size": { "width": 24, "height": 30 }
        },
        {
          "type": "spike",
          "position": { "along": 360, "across": 0, "up": 0 },
          "size": { "width": 24, "height": 30 }
        }
      ],
      "decorations": []
    },
    {
      "id": "seg-07-orb-finale",
      "mode": "real",
      "length": 700,
      "speed": 1.0,
      "terrain": {
        "type": "flat",
        "floor": { "function": "constant", "offset": 80 },
        "ceiling": null
      },
      "obstacles": [
        {
          "type": "spike",
          "position": { "along": 100, "across": 0, "up": 0 },
          "size": { "width": 24, "height": 30 }
        },
        {
          "type": "orb",
          "position": { "along": 220, "across": 0, "up": 130 },
          "size": { "width": 0, "height": 0 },
          "visual": { "color": null, "glow": 1, "orbSize": "medium" }
        },
        {
          "type": "spike",
          "position": { "along": 380, "across": 0, "up": 0 },
          "size": { "width": 24, "height": 30 }
        },
        {
          "type": "orb",
          "position": { "along": 560, "across": 0, "up": 130 },
          "size": { "width": 0, "height": 0 },
          "visual": { "color": null, "glow": 1, "orbSize": "large" }
        }
      ],
      "decorations": []
    },
    {
      "id": "seg-08-outro",
      "mode": "real",
      "length": 300,
      "speed": 1.0,
      "terrain": {
        "type": "flat",
        "floor": { "function": "constant", "offset": 80 },
        "ceiling": null
      },
      "obstacles": [],
      "decorations": []
    }
  ],
  "triggers": [
    {
      "id": "trg-intro-text",
      "type": "text",
      "position": 100,
      "duration": 2500,
      "easing": "linear",
      "params": { "text": "Jump Pads", "style": "fixed" }
    },
    {
      "id": "trg-top-land-hint",
      "type": "text",
      "position": 2050,
      "duration": 2800,
      "easing": "linear",
      "params": { "text": "Land on top to upgrade", "style": "fixed" }
    },
    {
      "id": "trg-the-wall",
      "type": "text",
      "position": 3800,
      "duration": 2000,
      "easing": "linear",
      "params": { "text": "Use the large pad", "style": "fixed" }
    },
    {
      "id": "trg-orb-intro",
      "type": "text",
      "position": 4540,
      "duration": 2800,
      "easing": "linear",
      "params": { "text": "Tap jump in mid-air!", "style": "fixed" }
    }
  ],
  "collectibles": [
    {
      "type": "star",
      "position": { "along": 3550, "across": 0, "up": 220 },
      "index": 0
    },
    {
      "type": "star",
      "position": { "along": 4795, "across": 0, "up": 240 },
      "index": 1
    },
    {
      "type": "star",
      "position": { "along": 4900, "across": 0, "up": 100 },
      "index": 2
    }
  ]
}
